import { render, staticRenderFns } from "./List.vue?vue&type=template&id=7d800022"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports